exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".info-btn-width {\n  width: 15%; }\n\n.delete-btn-width {\n  width: 7%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/reset_atm_code/all/reset_atm_code.all.scss
// module id = 1072
// module chunks = 1